import { QSpinner, useQAlert } from '@kubiq-base/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../state/ApiContext';
import { useAppContext } from '../../state/AppContext';

const Logout = (): JSX.Element => {
  const { t } = useTranslation();
  const { clearTokens, setEmail } = useAppContext();
  const { postRequest } = useApi();
  const { enqueueAlert } = useQAlert();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = React.useState(true);

  const logout = (): void => {
    clearTokens();
    setEmail('');
    navigate('/');
  };

  const invalidateTokens = async (): Promise<void> => {
    await postRequest('Login/Logout', {}, setIsLoggingOut, ['unauthorized'])
      .then(() => {
        enqueueAlert(t('loggedout'), { type: 'success', autoHideDuration: 5000 });
        logout();
      })
      .catch(() => {
        enqueueAlert(t('loggedout'), { type: 'success', autoHideDuration: 5000 });
        logout();
      });
  };

  React.useEffect(() => {
    invalidateTokens();
  }, []);

  return (
    <>
      {isLoggingOut && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 72 }}>
          <QSpinner />
        </div>
      )}
    </>
  );
};

export default Logout;
